import React, { Component } from "react";
import "../../index.css";
import "./css/Templates.css";
import ComponentManager from "../../Manager/ComponentManager";
import { DateFormat, EditorInfoType, FONT_SIZE } from '../../Constants/Constants';
import DocumentManager from "../../Manager/DocumentManager";
import Utility, { getFontSizeClass, getPageHeight, getVW, getIsFulfillment, getIsGoodsReceipt, getIsJournalEntry, getIsProductDocumentForBuySell, getCapitalized, getDateString, getIsInvoice } from "../../Utilities/Utility";
import { getLocalisedText } from '../../Translate/LanguageManager';
import DKEInvoiceSection, { eInvoiceSectionPosition } from "../../DKUILibrary/DKEInvoiceSection";
import DKCustomFieldSection from "../../DKUILibrary/DKCustomFieldSection";
import DKSignatureSection from "../../DKUILibrary/DKSignatureSection";
import AddressParser, { AddressType } from "../../Helper/AddressParser";
import { HTMLTag } from "../../Utilities/HTMLTag";
import DKIndiaTaxBreakdown from "../../DKUILibrary/DKIndiaTaxBreakdown";
import TopSectionAboveTableUtility from "../../Utilities/TopSectionAboveTableUtility";
import DKComponentListTable from "../../DKUILibrary/DKComponentListTable";
import DKCustomApprovalSection from "../../DKUILibrary/DKCustomApprovalSection";

export default class IndiaTemplate11 extends Component {//based on template 51 - India Template 10 
    spacingRatio = 0.25
    paddingLeft = getVW(Utility.convertToPrintScale(5, this.props.data.printScale))
    paddingRight = getVW(Utility.convertToPrintScale(5, this.props.data.printScale))

    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data,
        };
    }

    componentWillReceiveProps(nextProp) {
        this.setState({
            data: nextProp.data,
        });
    }

    render() {
        // Subtracting top and bottom border height from min page height
        let minHeight = getPageHeight(this.state.data.printScale);
        if (minHeight && minHeight.includes("vw")) {
            minHeight = `${Number(minHeight.replace("vw", "")) - Number(getVW(2).replace("vw", ""))}vw`;
        }

        return (
            <div id={HTMLTag.TEMPLATE_HOLDER} className='DocumentHolder ColumnDiv parent-width'
                style={{
                    justifyContent: 'space-between',
                    minHeight: minHeight,
                    border: '1px solid black'
                }}>
                <div id={HTMLTag.TEMPLATE_CONTENT} className='ColumnDiv parent-width' style={{ minHeight: minHeight }}>
                    <div className='parent-width'>
                        <div id={HTMLTag.TEMPLATE_HEADER}>
                            {this.getCompanySection()}
                            {this.state.data.showEInvoiceSection && this.getEInvoiceDetailsSection()}
                        </div>
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            margin: 'auto'
                        }}>
                            <tbody>
                                <tr>
                                    <td colSpan={2}
                                        style={{ width: '100%', verticalAlign: 'top' }}>
                                        {this.getCompanyTaxDetailsSection()}
                                    </td>
                                </tr>
                                {this.getDocumentDetailsSection()}
                                {Utility.getIsShowPlaceOfSupply(this.state.data) && this.getPlaceOfSupplyInfoSection()}
                                {(Utility.getIsShowSourceOfSupply(this.state.data) || Utility.getIsShowDestinationOfSupply(this.state.data)) && this.getSourceOfSupplyInfoSection()}
                                {this.getBillToShipToSection()}
                                {this.getEwayBillDetailsSection()}
                            </tbody>
                        </table>
                    </div>
                    <div id={HTMLTag.TEMPLATE_LT_ABOVE} className='parent-width'>
                        <DKCustomFieldSection data={this.state.data} onCustomFieldClick={this.props.onCustomFieldClick} style={this.getCustomFieldTableStyle()} customFieldPosition={'top'} isShowGrid />
                        {this.getChildCustomFieldsSection()}
                        {
                            TopSectionAboveTableUtility.getIsTopSectionAboveTableIsVisible() &&
                            <>
                                <div style={{ ...TopSectionAboveTableUtility.getTopSectionWithTableFontStyleProp(undefined, this.state.data.printScale) }}
                                    dangerouslySetInnerHTML={{ __html: TopSectionAboveTableUtility.getHtmlString(this.state.data) }} />
                                {ComponentManager.addVerticalSpace(5 * this.spacingRatio)}
                            </>
                        }
                    </div>
                    <div id={HTMLTag.TEMPLATE_LINE_TABLE} className='parent-width'>
                        {this.getProductTable()}
                        {Utility.getIsShowAccountProductTable(this.state.data) && ComponentManager.addVerticalSpace(30 * this.spacingRatio)}
                        {this.getEditableDocumentTable()}
                    </div>
                    <div id={HTMLTag.TEMPLATE_LT_BELOW} className='parent-width'>
                        {this.getAmountInWordsSection()}
                        {Utility.getIsShowExchangeRate(this.state.data) && ComponentManager.addVerticalSpace(15 * this.spacingRatio)}
                        {Utility.getIsShowExchangeRate(this.state.data) && this.getExchangeRateTable(this.getTableStyle(), this.state.data)}
                        {this.getTransactionDocumentTable(this.getTableStyle(), this.state.data)}
                        <DKCustomFieldSection data={this.state.data} onCustomFieldClick={this.props.onCustomFieldClick} style={this.getCustomFieldTableStyle()} customFieldPosition={'bottom'} isShowGrid />
                        {ComponentManager.addVerticalSpace(15 * this.spacingRatio)}
                        {getIsProductDocumentForBuySell(this.state.data) &&
                            Utility.getIsShowHsnSacTaxTable() &&
                            <DKIndiaTaxBreakdown
                                data={this.state.data}
                            />
                        }
                        {Utility.getIsIncludesBomProductTable() && <DKComponentListTable data={this.state.data} />}
                        <div id={HTMLTag.SIGNATURE} className="break-inside-avoid">
                            {this.state.data.showSignature && ComponentManager.addVerticalSpace(Utility.convertToPrintScale(30, this.state.data.printScale) * this.spacingRatio)}
                            {this.state.data.showSignature && ComponentManager.getSignature(this.state.data.signature, this.state.data.printScale)}
                        </div>
                        {this.getTermsAndConditionOrNotesSection()}
                        {(getIsFulfillment(this.state.data.type) || getIsGoodsReceipt(this.state.data.type)) && <DKSignatureSection data={this.state.data} onSignatureSectionClicked={this.props.tableClicked} />}
                    </div>
                    <div id={HTMLTag.TEMPLATE_FOOTER} className='parent-width mt-auto'>
                        {Utility.getIsShowCustomApprovalSection() && <DKCustomApprovalSection data={this.state.data} style={this.getTableStyle()} isThemeColor />}
                    </div>
                </div>
                {Utility.getGeneratedVisibility() && ComponentManager.getGenerateDocumentSection(this.state.data, this.spacingRatio, getVW(10 * this.spacingRatio), getVW(10 * this.spacingRatio))}
            </div>
        );
    }

    getCompanySection() {
        let emailString = ''
        const email = this.state.data.tenantInfo.email ?? ''

        if (email !== '') {
            emailString = ' ' + getLocalisedText('email') + ': ' + email
        }

        let phoneNumberString = ''
        const phone = this.state.data.tenantInfo.contactNumber ?? ''
        if (phone !== '') {
            phoneNumberString = ' ' + getLocalisedText('phone') + ': ' + phone
        }
        return <div className="RowDiv"
            style={{
                justifyContent: 'center',
                borderBottom: '1px solid black',
            }}>
            <div className="ColumnDiv" style={{ alignItems: 'left', flex: 1 }}>
                {ComponentManager.getLogoVisibility(this.state.data.showCompanyLogo, this.state.data.isReadOnlyMode, this.state.data.logo) && ComponentManager.getLogo(this.state.data.logo, Utility.convertToPrintScale(80, this.state.data.printScale), { position: 'relative' })}
                {ComponentManager.addVerticalSpace(10 * this.spacingRatio)}
            </div>
            <div className="ColumnDiv" style={{ alignItems: 'center', flex: 2 }}>
                <div className="ColumnDiv" style={{ justifyContent: "center", alignItems: "flex-end", alignSelf: 'baseline', width: '100%' }}>
                    {this.state.data.showCompanyName && <text className={"docFontStyleBold" + getFontSizeClass()}
                        style={{
                            textAlign: 'center',
                            alignSelf: 'center',
                            ...Utility.getFontStyleProp({ fontSize: FONT_SIZE.medium }, this.state.data.printScale)
                        }}>
                        {getLocalisedText(Utility.getCompanyName(this.state.data))}
                    </text>}
                    {this.state.data.showCompanyName && ComponentManager.addVerticalSpace(5 * this.spacingRatio)}
                    {this.state.data.showFrom && <div className={"docFontStyle" + getFontSizeClass()}
                        style={{
                            color: '#000000',
                            textAlign: 'center',
                            width: '100%',
                            ...Utility.getFontStyleProp({ fontSize: FONT_SIZE.regular, ownerType: Utility.getOwnerType(this.state.data, AddressType.from) }, this.state.data.printScale)
                        }}
                        dangerouslySetInnerHTML={{ __html: getLocalisedText(AddressParser.getRequisitonCustomAddressString(this.state.data.fromObj)) }}>
                    </div>}
                    {/* <div className={"docFontStyle" + getFontSizeClass()}
                        style={{
                            width: '100%',
                            marginTop: 0,
                            color: '#000000',
                            textAlign: 'center',
                            ...Utility.getFontStyleProp({ fontSize: FONT_SIZE.regular, ownerType: undefined }, this.state.data.printScale)
                        }}
                        dangerouslySetInnerHTML={{ __html: getLocalisedText((getIsOrder(this.state.data.type) || getIsBill(this.state.data.type)) ? this.state.data.billOrderCompanyStateNameCode : this.state.data.companyStateNameAndCode,) }}>
                    </div> */}
                    <div className={"docFontStyle" + getFontSizeClass()}
                        style={{
                            width: '100%',
                            marginTop: 0,
                            color: '#000000',
                            textAlign: 'center',
                            ...Utility.getFontStyleProp({ fontSize: FONT_SIZE.regular, ownerType: undefined }, this.state.data.printScale)
                        }}
                        dangerouslySetInnerHTML={{ __html: phoneNumberString + emailString }}>
                    </div>
                </div>
                <text className={"docFontStyleBold" + getFontSizeClass()}
                    style={{
                        ...Utility.getFontStyleProp({ fontSize: FONT_SIZE.medium }, this.state.data.printScale)
                    }}>
                    {getCapitalized(getLocalisedText(this.state.data.documentType))}
                </text>
            </div>
            <div className="ColumnDiv" style={{ alignItems: 'center', flex: 1, padding: getVW(20 * this.spacingRatio) }}>
                <DKEInvoiceSection
                    data={this.state.data}
                    position={eInvoiceSectionPosition.fixed}
                    showCancelledEInvoice
                />
                {this.getEInvoiceStatusSection()}
            </div>
        </div>
    }

    getEInvoiceDetailsSection() {
        let irn = this.state.data.irn ?? ''
        let ackNo = this.state.data.ackNo ?? ''
        let ackDt = this.state.data.ackDt ?? ''

        if (ackDt !== '') {
            const parseDate = Date.parse(ackDt);
            if (!isNaN(parseDate) && parseDate > 0) {
                ackDt = getDateString(new Date(parseDate), DateFormat.YYYY_MM_DD_DASH)
            }
        }
        if (irn === '' && ackNo === '' & ackDt === '') {
            return <></>
        }
        return <div className="RowDiv"
            style={{
                width: '98.9%',
                borderTop: '1px solid black',
                justifyContent: 'center',
                paddingLeft: this.paddingLeft,
                paddingRight: this.paddingRight,
                paddingTop: getVW(20 * this.spacingRatio),
                paddingBottom: getVW(20 * this.spacingRatio),
                ...Utility.getFontStyleProp({ fontSize: FONT_SIZE.small }, this.state.data.printScale)
            }}>
            <div className="RowDiv" style={{ alignItems: 'left', flex: 5 }}>
                IRN:
                <b>
                    {irn}
                </b>
            </div>
            <div className="RowDiv" style={{ justifyContent: 'flex-end', flex: 3 }}>
                Ack No:
                <b>
                    {ackNo}
                </b>
            </div>
            <div className="RowDiv" style={{ justifyContent: 'flex-end', flex: 2 }}>
                Ack Date:
                <b>
                    {ackDt}
                </b>
            </div>
        </div>
    }

    getEInvoiceStatusSection() {
        let isCancelled = false
        let status = this.state.data.eInvoiceStatus ?? ''
        if (status !== '') {
            if (status === 'CANCELLED') {
                isCancelled = true
            }
        }

        if (isCancelled) {
            return <div className={"docFontStyleBold" + getFontSizeClass()}
                style={{
                    paddingTop: getVW(10 * this.spacingRatio), paddingBottom: getVW(10 * this.spacingRatio),
                    width: '100%',
                    marginTop: 0,
                    color: '#000000',
                    textAlign: 'left',
                    ...Utility.getFontStyleProp({ fontSize: FONT_SIZE.small, ownerType: undefined }, this.state.data.printScale)
                }}>
                CANCELLED
            </div>
        }

        return <></>
    }

    getCompanyTaxDetailsSection() {
        const taxDetailsList = [
            { label: 'Plant State', key: 'state', width: '24%' },
            { label: 'GSTIN No', key: 'gstin', width: '26%' },
            { label: 'PAN No', key: 'panIndia', width: '20%' },
            { label: 'CIN No', key: 'cinIndia', width: '30%' },
        ]
        let taxes = taxDetailsList.map(element => {
            return <div className="RowDiv" style={{
                alignItems: 'left',
                width: element.width,
                paddingLeft: this.paddingLeft,
                // paddingRight: this.paddingRight,
            }}>
                <text className={"docFontStyle" + getFontSizeClass()}
                    style={{

                        ...Utility.getFontStyleProp({ fontSize: FONT_SIZE.regular }, this.state.data.printScale)
                    }}>
                    {element.label}
                </text>:
                &nbsp;
                <text className={"docFontStyleBold" + getFontSizeClass()}
                    style={{
                        ...Utility.getFontStyleProp({ fontSize: FONT_SIZE.regular }, this.state.data.printScale)
                    }}>
                    {this.state.data.tenantInfo[element.key] ?? ''}
                </text>
            </div>
        });

        return <div className="RowDiv"
            style={{
                justifyContent: 'center',
                paddingTop: getVW(10 * this.spacingRatio),
                paddingBottom: getVW(10 * this.spacingRatio),
                ...Utility.getFontStyleProp({ fontSize: FONT_SIZE.regular }, this.state.data.printScale)
            }}>
            {taxes}
        </div>
    }

    getDocumentType() {
        return <div className="RowDiv pl-s pt-s pb-s parent-width"
            style={{
                alignItems: 'center',
                flexDirection: Utility.getIsArabicLang() ? 'row-reverse' : 'row',
                width: '100%',
            }}>
            <text className={"docFontStyleBold" + getFontSizeClass()}
                style={{
                    ...Utility.getFontStyleProp({ fontSize: FONT_SIZE.large }, this.state.data.printScale)
                }}>
                {getLocalisedText(this.state.data.documentType)}
            </text>
        </div>;
    }

    getDocumentDetailsSection() {
        const documentDetailList = Utility.getDocumentDetailsList(this.state.data)
        const selectedDetailList = documentDetailList.filter(x => x.isSelected).sort((a, b) => a.index - b.index)

        let leftDetailsList = []
        let rightDetailsList = []

        if (selectedDetailList.length === 0) {
            return <></>
        }
        const maxLeftCount = selectedDetailList.length === 1 ? 1 : 2
        if (selectedDetailList.length > 0) {
            leftDetailsList = maxLeftCount === 1 ? [selectedDetailList[0]] : [selectedDetailList[0], selectedDetailList[1]]

            if (selectedDetailList.length > maxLeftCount) {
                rightDetailsList = selectedDetailList.splice(maxLeftCount)
            }
        }

        return this.getTableColumnTd(this.getDocumentDetailsList(leftDetailsList), this.getDocumentDetailsList(rightDetailsList))

    }

    getDocumentDetailsValue(element) {
        var value = ''
        if (element.key !== undefined) {
            value = this.state.data[element.key]
        }
        else if (element.customFieldValue !== undefined) {
            value = element.customFieldValue
        }

        return value
    }

    getDocumentDetailsList(items) {
        var leftColumnData = []
        var rightColumnData = []

        items.forEach((element, index) => {
            if (index % 2 === 0) {
                leftColumnData.push(element)
            }
            else {
                rightColumnData.push(element)
            }
        });

        var documentDetailsMapping = []
        for (let index = 0; index < leftColumnData.length; index++) {
            const left = leftColumnData[index]
            if (rightColumnData.length > index) {
                let right = rightColumnData[index]
                documentDetailsMapping.push({
                    left: left,
                    right: right
                })
            }
            else {
                documentDetailsMapping.push({
                    left: left,
                    right: undefined
                })
            }
        }

        return documentDetailsMapping.map(element => {
            return this.getLeftAndRightDetailsSection(element.left, element.right)
        });
    }

    getRowValueSection(title, value) {
        // const paddingHorizontal = getVW(Utility.convertToPrintScale(10, this.state.data.printScale))
        return <div className="RowDiv"
            style={{
                // paddingTop: getVW(Utility.convertToPrintScale(2, this.state.data.printScale)),
                // paddingBottom: getVW(Utility.convertToPrintScale(2, this.state.data.printScale)),
                paddingLeft: this.paddingLeft,
                // paddingRight: this.paddingRight,
                flex: 1,
                // paddingLeft: paddingHorizontal,
                // paddingRight: paddingHorizontal,
                width: '-webkit-fill-available',
                alignSelf: 'baseline',
            }}>
            <text className={"docFontStyle" + getFontSizeClass()}
                style={{
                    color: this.state.data.themeColor,
                    ...Utility.getFontStyleProp({ fontSize: FONT_SIZE.regular }, this.state.data.printScale)
                }}>
                {getLocalisedText(title)}
            </text>
            <text className={"docFontStyle" + getFontSizeClass()}
                style={{
                    alignSelf: 'baseline',
                    color: this.state.data.themeColor,
                    ...Utility.getFontStyleProp({ fontSize: FONT_SIZE.regular }, this.state.data.printScale)
                }}>
                : &nbsp;
            </text>
            <text className={"docFontStyleBold" + getFontSizeClass()}
                style={{
                    ...Utility.getFontStyleProp({ fontSize: FONT_SIZE.regular }, this.state.data.printScale)
                }}>
                {value}
            </text>
        </div>
    }

    getLeftAndRightDetailsSection(left, right) {
        return <div className="RowDiv">
            {left ?
                this.getRowValueSection(
                    left.label,
                    this.getDocumentDetailsValue(left)
                ) : <></>
            }
            {(left && right) ?
                ComponentManager.addHorizontalSpace(Utility.convertToPrintScale(20, this.state.data.printScale))
                : <></>}
            {right ?
                this.getRowValueSection(
                    right.label,
                    this.getDocumentDetailsValue(right)
                ) : <></>
            }
            {(right) ?
                ComponentManager.addHorizontalSpace(Utility.convertToPrintScale(20, this.state.data.printScale))
                : <></>}
        </div>
    }


    getPlaceOfSupplyInfoSection() {
        // const reverseCharge = this.getRowValueSection('Reverse Charges', 'Not Applicable')
        const placeOfSupply = this.getRowValueSection(getLocalisedText('place_of_supply'), this.state.data.placeOfSupply)

        return this.getTableColumnTd(placeOfSupply, <></>)
    }

    getSourceOfSupplyInfoSection() {
        const sourceOfSupply = Utility.getIsShowSourceOfSupply(this.state.data) && this.getRowValueSection(getLocalisedText('source_of_supply'), this.state.data.sourceOfSupply)
        const destinationOfSupply = Utility.getIsShowDestinationOfSupply(this.state.data) && this.getRowValueSection(getLocalisedText('destination_of_supply'), this.state.data.destinationOfSupply)

        return this.getTableColumnTd(sourceOfSupply, destinationOfSupply)
    }

    getBillToShipToSection() {
        return <tr>
            <td style={{ border: '1px solid', width: '50%', verticalAlign: 'top' }}>
                {(this.state.data.showClientBillToAddress)
                    && <div className="RowDiv"
                        style={{
                            width: '-webkit-fill-available',
                            // borderTop: '1px solid',
                            // borderBottom: '1px solid',
                            paddingTop: getVW(5 * this.spacingRatio),
                            paddingBottom: getVW(5 * this.spacingRatio),
                            paddingLeft: this.paddingLeft,
                        }}>
                        <div className="ColumnDiv parent-width">
                            {ComponentManager.getDescriptionSection(
                                this.state.data.billToTitle,
                                Utility.getClientBillToAddress(this.state.data),
                                "100%",
                                this.state.data.themeColor,
                                false,
                                '#000000',
                                getVW(0),
                                Utility.getOwnerType(this.state.data, AddressType.billTo),
                                this.state.data.printScale
                            )}
                            {ComponentManager.getDescriptionSection(
                                "",
                                this.state.data.billToAddressStateCode,
                                "100%",
                                this.state.data.themeColor,
                                false,
                                undefined,
                                0,
                                undefined,
                                this.state.data.printScale
                            )}
                        </div>
                    </div>}
            </td>
            <td style={{ border: '1px solid', width: '50%', verticalAlign: 'top' }}>
                {this.state.data.showClientShipToAddress && <div className="ColumnDiv parent-width" style={{
                    paddingLeft: this.paddingLeft
                }}>
                    {ComponentManager.getDescriptionSection(
                        this.state.data.shipToTitle,
                        Utility.getClientShipToAddress(this.state.data),
                        "100%",
                        this.state.data.themeColor,
                        false,
                        '#000000',
                        getVW(0),
                        Utility.getOwnerType(this.state.data, AddressType.shipTo),
                        this.state.data.printScale
                    )}
                    {ComponentManager.getDescriptionSection(
                        "",
                        this.state.data.shipToAddressStateCode,
                        "100%",
                        this.state.data.themeColor,
                        false,
                        undefined,
                        0,
                        undefined,
                        this.state.data.printScale
                    )}
                </div>}
            </td>
        </tr>
    }

    getIsShowEwayBill() {
        return getIsInvoice(this.state.data.type)
    }

    getEwayBillDetailsSection() {
        const left = [
            { label: getLocalisedText('delivery_order_doc_and_date'), key: 'deliveryOrderDocNoAndDate' },
            { label: getLocalisedText('e_way_bill_doc_and_date'), key: 'ewayBillNoAndDate' },
        ]

        const right = [
            // { label: getLocalisedText('party_order_doc_and_date'), key: 'customerOrderNumber' },
            { label: getLocalisedText('mode_of_transport'), key: 'modeOfTransport' },
        ]

        const leftSection = left.map(element => {
            const value = this.state.data[element.key] ?? ''
            return this.getRowValueSection(element.label, value)
        });

        const rightSection = right.map(element => {
            const value = this.state.data[element.key] ?? ''
            return this.getRowValueSection(element.label, value)
        });

        if (this.getIsShowEwayBill()) {
            return this.getTableColumnTd(leftSection, rightSection)
        }

    }

    getChildCustomFieldsSection() {
        let childCF = <DKCustomFieldSection data={this.state.data} onCustomFieldClick={this.props.onCustomFieldClick} style={this.getCustomFieldTableStyle()} customFieldPosition={undefined} childCustomField isShowGrid />
        if (childCF !== <></>) {
            return <div className="RowDiv parent-width" style={{ borderTop: '1px solid black' }}>
                {childCF}
            </div>
        }

    }

    getTermsAndConditionOrNotesSection() {
        const termsAndConditionSection = (this.state.data.showTermsAndCondition && this.state.data.termsAndCondition) ?
            <div className="RowDiv"
                style={{
                    width: '-webkit-fill-available',
                    paddingTop: getVW(5 * this.spacingRatio),
                    paddingBottom: getVW(5 * this.spacingRatio),
                    paddingLeft: this.paddingLeft,
                }}>
                {ComponentManager.getTermsAndConditionOrNotesSection(
                    Utility.getTermsAndConditionTitle(getLocalisedText('terms_&_condition')),
                    getLocalisedText(this.state.data.termsAndCondition),
                    "100%",
                    this.state.data.themeColor,
                    undefined,
                    undefined,
                    undefined,
                    this.state.data.printScale,
                    Utility.getTnCOrNotesFontSettingsByType(EditorInfoType.termsAndCondition)
                )}
            </div> : undefined

        const notesSection = (this.state.data.showNotes && this.state.data.notes) ?
            <div className="RowDiv"
                style={{
                    width: '-webkit-fill-available',
                    paddingTop: getVW(5 * this.spacingRatio),
                    paddingBottom: getVW(5 * this.spacingRatio),
                    paddingLeft: this.paddingLeft,
                }}>
                {ComponentManager.getTermsAndConditionOrNotesSection(
                    Utility.getNotesTitle(getIsJournalEntry(this.state.data.type) ? getLocalisedText('memo') : getLocalisedText('notes')),
                    getLocalisedText(this.state.data.notes),
                    "100%",
                    this.state.data.themeColor,
                    undefined,
                    undefined,
                    undefined,
                    this.state.data.printScale,
                    Utility.getTnCOrNotesFontSettingsByType(EditorInfoType.notes)
                )}
            </div> : undefined

        return (
            <table
                id={HTMLTag.TERMS_NOTE_PREFIX}
                style={{
                    alignItems: "flex-start",
                    justifyContent: 'space-between',
                    backgroundColor: "white",
                    border: '1px solid',
                    paddingTop: getVW(5 * this.spacingRatio),
                    paddingBottom: getVW(5 * this.spacingRatio),
                    width: '100%'
                }}
            >
                <tbody>
                    <tr>
                        {termsAndConditionSection &&
                            <td style={{ width: '50%', verticalAlign: 'top' }}>
                                {termsAndConditionSection}
                            </td>
                        }
                        {notesSection &&
                            <td style={{ width: '50%', verticalAlign: 'top' }}>
                                {notesSection}
                            </td>
                        }
                    </tr>
                </tbody>
            </table>
        )
    }


    getAmountInWordsSection() {
        const amountInWords = this.state.data.amountInWords ?? undefined
        if (amountInWords) {
            return <div style={{
                border: '1px solid black'
            }}>
                {this.getRowValueSection(getLocalisedText('amount_in_words'), amountInWords)}
            </div>
        }
    }

    getTableColumnTd(left, right) {
        return <tr>
            <td style={{ border: '1px solid', width: '50%', verticalAlign: 'top' }}>
                {left}
            </td>
            <td style={{ border: '1px solid', width: '50%', verticalAlign: 'top' }}>
                {right}
            </td>
        </tr>
    }

    getEditableDocumentTable() {
        return ComponentManager.getDKDocumentTable(
            this.props.tableColumn,
            this.getTableStyle(),
            this.props.data,
            this.props.tableClicked,
            this.props.stockTableClicked,
            this.props.onUpdateDataCallback,
            this.props.paymentTableClicked,
            this.props.additionalTableCallback,
        )
    }

    getProductTable() {
        if (Utility.getIsShowAccountProductTable(this.state.data)) {
            return ComponentManager.getDKProductTable(
                Utility.getTableColumnForAccountProduct(),
                this.getTableStyle(),
                this.props.data,
                this.props.tableClicked,
                this.props.stockTableClicked,
                this.props.onUpdateDataCallback,
                this.props.paymentTableClicked,
                this.props.additionalTableCallback,
            )
        }
    }

    getTableStyle() {
        let style = DocumentManager.getTableDefaultStyle();
        style.headerTextColor = this.state.data.themeColor;
        style.footerTextColor = this.state.data.themeColor;
        // style.headerBorderColor = "#BBBABA";
        // style.itemBorderColor = "#BBBABA";
        style.headerBorderColor = "#000000";
        style.itemBorderColor = "#000000";
        style.footerBackgroundColor = "white";
        // style.footerBorderColor = "#BBBABA";
        style.footerBorderColor = "#000000";
        style.headerBackgroundColor = "transparent";
        return style;
    }


    getCustomFieldTableStyle() {
        let style = {}
        style.columnCount = 3
        style.paddingLeft = this.paddingLeft
        style.columnWidths = Utility.getIsArabicLang() ? ['33%', '33%', '33%'] : ['33%', '33%', '33%']
        return style;
    }

    getExchangeRateTable(tableStyle, data) {
        const style = {
            ...tableStyle,
            paddingTop: 4,
            paddingBottom: 4,
            paddingLeft: 6,
            paddingRight: 13,
        };

        return (
            <div id={HTMLTag.EXCHANGE_RATE} className="RowDiv" style={{ justifyContent: "flex-end" }}>
                <div style={{ width: "45%" }}>
                    {ComponentManager.getExchangeRateTable(style, data)}
                </div>
            </div>
        );
    }

    getTransactionDocumentTable(tableStyle, data) {
        const style = {
            ...tableStyle,
            paddingTop: 4,
            paddingBottom: 4,
            paddingLeft: 6,
            paddingRight: 13,
        };

        return (
            <div id={HTMLTag.TRANSACTION_DOCUMENT_TABLE} className="RowDiv" style={{ justifyContent: "flex-end" }}>
                <div style={{ width: "65%" }}>
                    {ComponentManager.getTransactionDocumentTable(style, data)}
                </div>
            </div>
        );
    }
}
